import { clsx } from 'clsx';
import i18n from 'i18n-react';
import { Link } from 'react-router-dom';

import { ContentHeader } from 'components/ContentHeader/ContentHeader';

import c from './_fastTrackStatusBanner.module.scss';

export interface FastTrackStatusBannerProps {
  answered: number;
  onAbandon: () => void;
}

export function FastTrackStatusBanner({ answered, onAbandon }: FastTrackStatusBannerProps) {
  return (
    <div className={clsx('trainingGrid', 'fast-track', c.wrapper)}>
      <span className="subHeader">
        <ContentHeader
          header={i18n.translate('contentHeaders.fastTrack')}
          subtitle={i18n.translate('pageDescriptions.fastTrack')}
          line
          pageHeader
        />
      </span>
      <div className={clsx('fast-track__actions', c.fastTrackActions)}>
        <Link
          to={`/main/fasttrack/chapter/0/${answered}`}
          className={clsx('fast-track__btn', 'fast-track__btn--continue', c.fastTrackBtn, c.fastTrackBtnContinue)}
        >
          {i18n.translate('trainingScreens.fastTrackContinue')}
        </Link>
        <button
          type="button"
          className={clsx('fast-track__btn', 'fast-track__btn--abandon', c.fastTrackBtn, c.fastTrackBtnAbandon)}
          onClick={onAbandon}
        >
          {i18n.translate('trainingScreens.fastTrackMoveToFull')}
        </button>
      </div>
    </div>
  );
}
